import InputType from "@/services/Input/InputType.js";
import OutputType from "@/services/Input/OutputType.js";
import AppModule from "@/services/App/AppModule.js";

// see details: "@/services/Input/DataCatalog.js"
export default {
  DispatchID: {
    Label: "Barang",
    Type: InputType.ID,
    Required: true,
    RelatedValue: "DispatchName",
    RelatedModule: AppModule.Item,
    RelatedIsActive: "DispatchIsActive",
    Active: true
  },
  ItemID: {
    Label: "Barang",
    Type: InputType.ID,
    Required: true,
    RelatedValue: "DispatchName",
    RelatedModule: AppModule.Item,
    RelatedIsActive: "DispatchIsActive"
  },
  DispatchName: {
    Label: "Nama",
    Type: InputType.Text,
    MaxLength: 255,
    Required: true
  },
  Qty: {
    Label: "Qty",
    Type: InputType.Integer,
    MinValue: 1,
    MaxLength: 11,
    Required: true,
    Valid: true
  },
  QtyInvoice: {
    Label: "Qty Jual",
    Type: InputType.Integer,
    ReadOnly: true
  },
  PackagingName: {
    Label: "Kemasan",
    Type: InputType.Select,
    Required: true
  },
  SellPrice: {
    Label: "Harga Jual",
    Type: InputType.Integer,
    MinValue: 0,
    MaxLength: 11,
    Required: true,
    Output: OutputType.Integer.Currency
  },
  Total: {
    Label: "Sub Total",
    Type: InputType.Integer,
    ReadOnly: true,
    Output: OutputType.Integer.Currency
  },
  PackagingValue: {
    Label: "Jumlah Kemasan",
    Type: InputType.Integer,
    ReadOnly: true
  },
  SKU: {
    Label: "SKU",
    Type: InputType.Text,
    ReadOnly: true
  },
  Packaging: {
    Label: "Kemasan",
    Type: InputType.Text,
    ReadOnly: true
  },
  IsClosed: {
    Label: "Status",
    Type: InputType.Boolean,
    Output: OutputType.Boolean.OpenClosed
  },
  // support
  Stock: {
    Label: "Stok",
    Type: InputType.Integer,
    ReadOnly: true
  },
  DispatchImageSrc: {
    Label: "Gambar",
    Type: InputType.Text,
    ReadOnly: true
  },
  QtyAvailable: {
    Label: "Qty SO",
    Type: InputType.Integer,
    ReadOnly: true
  }
}